var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.$ceres.isSSR,
          expression: "!$ceres.isSSR",
        },
      ],
      staticClass: "cookie-bar",
      class: {
        out: !_vm.isVisible,
        // 'border-top bg-white': isVisible,
        // 'fixed-bottom': !isShopBuilder || false
      },
    },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isVisible,
            expression: "isVisible",
          },
        ],
        staticClass: "overlay",
      }),
      _vm._v(" "),
      _vm.isVisible
        ? _c(
            "div",
            {
              class: [
                "container-max cookie-window",
                { isExpanded: _vm.isExpanded },
              ],
              attrs: { "data-cookie-bar": "" },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isExpanded,
                      expression: "!isExpanded",
                    },
                  ],
                  staticClass: "py-3",
                  class: _vm.classes,
                  style: _vm.styles,
                },
                [
                  _c("div", { staticClass: "pb-2" }, [
                    _c("div", { staticClass: "cookiebar-header" }, [
                      _c("h3", { staticClass: "cookiebar-headline" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "cookie-icon",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 512 512",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.cookieBarHeadline"
                              )
                            ) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "language-container" }, [
                        _c("div", { staticClass: "dropdown" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-link dropdown-toggle",
                              attrs: {
                                type: "button",
                                id: "dropdownMenuButton-cookieBar",
                                "aria-haspopup": "true",
                                "aria-expanded": "false",
                              },
                            },
                            [
                              _c("span", { staticClass: "text-uppercase" }, [
                                _vm._v(_vm._s(_vm.currentLanguage)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu",
                              attrs: {
                                "aria-labelledby":
                                  "dropdownMenuButton-cookieBar",
                              },
                            },
                            _vm._l(_vm.languageList, function (langItem) {
                              return !_vm.isCurrentLanguage(langItem)
                                ? _c(
                                    "a",
                                    {
                                      key:
                                        _vm.getLangIso(langItem) ||
                                        langItem.name ||
                                        langItem,
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        href: _vm.hrefFor(langItem),
                                        "data-update-url": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-uppercase" },
                                        [
                                          _vm._v(
                                            _vm._s(langItem.name || langItem)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", { domProps: { innerHTML: _vm._s(_vm.text) } }),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "d-block mb-4 cookieBarMoreSettings",
                          attrs: {
                            href: "#",
                            "data-testing": "cookie-bar-show-more-information",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.isExpanded = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.cookieBarMoreSettings"
                              )
                            )
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block btn-default btn-appearance mb-2 mt-0 accept-button",
                        attrs: { "data-testing": "cookie-bar-accept-all" },
                        on: {
                          click: function ($event) {
                            _vm.acceptAll()
                            _vm.close()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.cookieBarAcceptAll"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.isExpanded
                ? _c(
                    "div",
                    {
                      staticClass: "row py-3",
                      class: _vm.classes,
                      style: _vm.styles,
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12 mb-3" },
                        [
                          _c("privacy-settings", {
                            attrs: { "consent-groups": _vm.consentGroups },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-primary text-appearance d-inline-block mb-3",
                            attrs: {
                              href: "#",
                              "data-testing":
                                "cookie-bar-hide-more-information",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                _vm.isExpanded = false
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.cookieBarBack"
                                  )
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c("div", [
                          _c("div", { staticClass: "mt-2" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-block btn-default btn-appearance",
                                attrs: {
                                  "data-testing":
                                    "cookie-bar-expanded-accept-all",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.acceptAll()
                                    _vm.close()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.cookieBarAcceptAll"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.showRejectAll
                            ? _c("div", { staticClass: "mt-2" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-block btn-default btn-appearance",
                                    attrs: {
                                      "data-testing":
                                        "cookie-bar-expanded-deny-all",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.denyAll()
                                        _vm.close()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.cookieBarDenyAll"
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-block btn-default",
                                attrs: {
                                  "data-testing": "cookie-bar-expanded-save",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.storeConsents()
                                    _vm.close()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.cookieBarSave"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-appearance",
                attrs: {
                  "aria-label": _vm.$translate(
                    "Ceres::Template.cookieBarPrivacySettings"
                  ),
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    _vm.isCollapsed = false
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-shield float-none" }),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-sm-inline-block" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.cookieBarPrivacySettings")
                    )
                  ),
                ]),
              ]
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }